import { Breadcrumb } from 'components/breadcrumb'
import { PecSwitch, PrivateRoute } from 'components/route'
import { useFlags } from 'config/useFlagsContext'
import { Fragment } from 'react'
import { Redirect, useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions.generated'
import CadastrarImovelView from 'view/cadastro-imovel/CadastrarImovelView'
import EditarImovelView from 'view/cadastro-imovel/EditarImovelView'
import { VisualizarImovelView } from 'view/visualizacao-imovel/VisualizarImovelView'

import { TERRITORIO_TABS_ROUTE, TerritorioViewTabEnum } from './model'
import { FILTROS_AVANCADOS_MODAL_ROUTE, PINO_TERRITORIO_MODAL_ROUTE } from './territorio-mapas/model-territorioMapa'
import { VisualizacaoTerritorialView } from './VisualizacaoTerritorialView'

export function VisualizacaoTerritorialRootView() {
  const match = useRouteMatch()
  const { MAPA_TERRITORIO_ENABLED } = useFlags()

  const listaDeImoveisPath = `${match.url}/${TERRITORIO_TABS_ROUTE[TerritorioViewTabEnum.LISTA_DE_IMOVEIS]}`
  const mapaDoTerritorioPath = `${match.url}/${TERRITORIO_TABS_ROUTE[TerritorioViewTabEnum.MAPA_DO_TERRITORIO]}`

  return (
    <Fragment>
      <Breadcrumb title='Acompanhamento do território' />
      <PecSwitch>
        <PrivateRoute
          permission={Permissions.gestaoDeCadastros.acompanhamentoDoTerritorio}
          path={`${match.url}/visualizarImovel/:imovelId(\\d+)`}
          component={VisualizarImovelView}
        />
        <PrivateRoute
          permission={Permissions.gestaoDeCadastros.acompanhamentoDoTerritorio}
          path={`${match.url}/cadastrarImovel`}
          component={CadastrarImovelView}
          exact
        />
        <PrivateRoute
          permission={Permissions.gestaoDeCadastros.acompanhamentoDoTerritorio}
          path={`${match.url}/editarImovel/:imovelId(\\d+)`}
          exact
          component={EditarImovelView}
        />
        <Redirect exact from={`${match.url}`} to={listaDeImoveisPath} />
        <PrivateRoute
          permission={Permissions.gestaoDeCadastros.acompanhamentoDoTerritorio}
          path={listaDeImoveisPath}
          exact
          render={() => <VisualizacaoTerritorialView activeTab={TerritorioViewTabEnum.LISTA_DE_IMOVEIS} />}
        />
        {MAPA_TERRITORIO_ENABLED && (
          <PrivateRoute
            permission={Permissions.gestaoDeCadastros.acompanhamentoDoTerritorio}
            path={[
              `${mapaDoTerritorioPath}/:mapaSidebarNavItem?/${PINO_TERRITORIO_MODAL_ROUTE}/:imovelId(\\d+)`,
              `${mapaDoTerritorioPath}/:mapaSidebarNavItem?/:filtrosAvancados(${FILTROS_AVANCADOS_MODAL_ROUTE})?`,
            ]}
            exact
            render={() => <VisualizacaoTerritorialView activeTab={TerritorioViewTabEnum.MAPA_DO_TERRITORIO} />}
          />
        )}
      </PecSwitch>
    </Fragment>
  )
}
